import App from "../../App";
import IFeqData, { IQuestion } from "../../interfaces/ILabyData";
import { shuffleArray } from '../../utils/utils';
import { listeDeQuestions } from '../../interfaces/ILabyData';

export default class QuestionManager {

    app:App;
    donnees?:IFeqData;

    // Liste des questions ajoutées au hasard selon le niveau du labyrinthe
    private questionsListe1:listeDeQuestions = new Array<string>();
    private questionsListe2:listeDeQuestions = new Array<string>();
    private questionsListe3:listeDeQuestions = new Array<string>();
    private questionsListe4:listeDeQuestions = new Array<string>();
    private questionsListe5:listeDeQuestions = new Array<string>();
        
    constructor(app:App){
        this.app = app;
    }

    public init(){
        this.donnees = this.app.donneesLaby;
    }


    public remplirQuestionListe(liste:listeDeQuestions, niveau:number){
        const paramQuestion = this.app.urlParams.question;        
        const lesQuestions = this.app.donneesLaby?.labyrinthes[(niveau-1)].questions as IQuestion[];
        for (var i=0; i<lesQuestions?.length; i++){
            liste.push(lesQuestions[i].id);
        }
        if (paramQuestion){
            // Question spécifiée par un paramètre dans l'URL
            // Pour le debogage question par question, on ne mélangera pas l'array
            // et les questions commencent à partir de celle spécifiée
            const indexQuestion = liste.indexOf(paramQuestion);
            for (i=0; i<indexQuestion; i++){
                liste.splice(0,1);
            }
        } else {
            liste = shuffleArray(liste);
        }
        return liste;
    }

    public getQuestionListByNiveau(niveau:number):listeDeQuestions{
        
        let currentList;
        switch(niveau){
            case 1: currentList = this.questionsListe1; break;
            case 2: currentList = this.questionsListe2; break;
            case 3: currentList = this.questionsListe3; break;
            case 4: currentList = this.questionsListe4; break;
            case 5: currentList = this.questionsListe5; break;
            default: currentList = this.questionsListe1; break;
        }
        if (currentList.length < 1){            
            this.remplirQuestionListe(currentList, niveau);
        }
        return currentList;
    }

    public getDataQuestionFromQuestionId(questionId:string, niveau:number):IQuestion{
        let indexQuestion = 0;
        const listQuestion = this.app.donneesLaby?.labyrinthes[(niveau-1)].questions as IQuestion[];
        for (var i=0; i<listQuestion.length; i++){
            if (listQuestion[i].id === questionId){
                indexQuestion = i;
                break;
            }
        }
        // Retourne la question recherchée OU la première si elle n'existe pas.
        return listQuestion[indexQuestion];
    }
    
    public getNextQuestion(niveau:number):IQuestion|undefined{
        const listeDeQuestions = this.getQuestionListByNiveau(niveau);
        
        const currentQuestionId = listeDeQuestions.splice(0, 1)[0];
        
        const laQuestion = this.getDataQuestionFromQuestionId(currentQuestionId, niveau);
        
        if (laQuestion) return laQuestion;
        return undefined;
    }

}